export default {
  // Common buttons
  "pages.common.ok": "OK",
  "pages.common.cancel": "Cancel",
  "pages.layouts.userLayout.title":
    "Ant Design is the most influential web design specification in Xihu district",
  "pages.login.accountLogin.tab": "Account Login",
  "pages.login.accountLogin.errorMessage":
    "Incorrect username/password(admin/ant.design)",
  "pages.login.failure": "Login failed, please try again!",
  "pages.login.success": "Login successful!",
  "pages.login.username.placeholder": "Username: admin or user",
  "pages.login.username.required": "Please input your username!",
  "pages.login.password.placeholder": "Password: ant.design",
  "pages.login.password.required": "Please input your password!",
  "pages.login.phoneLogin.tab": "Phone Login",
  "pages.login.phoneLogin.errorMessage": "Verification Code Error",
  "pages.login.phoneNumber.placeholder": "Phone Number",
  "pages.login.phoneNumber.required": "Please input your phone number!",
  "pages.login.phoneNumber.invalid": "Phone number is invalid!",
  "pages.login.captcha.placeholder": "Verification Code",
  "pages.login.captcha.required": "Please input verification code!",
  "pages.login.phoneLogin.getVerificationCode": "Get Code",
  "pages.getCaptchaSecondText": "sec(s)",
  "pages.login.rememberMe": "Remember me",
  "pages.login.forgotPassword": "Forgot Password ?",
  "pages.login.submit": "Login",
  "pages.login.loginWith": "Login with :",
  "pages.login.registerAccount": "Register Account",
  "pages.login.logo.title": "No.1 Hoops",
  "pages.login.logo.subtitle": "Management System",
  "pages.login.loginType.email": "Email Login",
  "pages.login.loginType.phone": "Phone Login",
  "pages.login.loginType.emailLabel": "Email",
  "pages.login.loginType.phoneLabel": "Phone",
  "pages.login.email.placeholder": "Please enter email",
  "pages.login.email.required": "Please enter email",
  "pages.login.email.invalid": "Please enter a valid email address",
  "pages.login.phone.placeholder": "Please enter phone number",
  "pages.login.phone.required": "Please enter phone number",
  "pages.login.phone.invalid": "Please enter a valid phone number",
  "pages.login.password.placeholder": "Please enter password",
  "pages.login.errorMessage.email": "Email or password is incorrect",
  "pages.login.errorMessage.phone": "Phone number or password is incorrect",
  "pages.login.pageTitle": "Login - No.1 Hoops Management System",
  "pages.welcome.link": "Welcome",
  "pages.welcome.alertMessage":
    "Faster and stronger heavy-duty components have been released.",
  "pages.404.subTitle": "Sorry, the page you visited does not exist.",
  "pages.404.buttonText": "Back Home",
  "pages.admin.subPage.title": "This page can only be viewed by Admin",
  "pages.admin.subPage.alertMessage":
    "Umi ui is now released, welcome to use npm run ui to start the experience.",
  "pages.searchTable.createForm.newRule": "New Rule",
  "pages.searchTable.updateForm.ruleConfig": "Rule configuration",
  "pages.searchTable.updateForm.basicConfig": "Basic Information",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Rule Name",
  "pages.searchTable.updateForm.ruleName.nameRules":
    "Please enter the rule name!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Rule Description",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder":
    "Please enter at least five characters",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "Please enter a rule description of at least five characters!",
  "pages.searchTable.updateForm.ruleProps.title": "Configure Properties",
  "pages.searchTable.updateForm.object": "Monitoring Object",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Rule Template",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Rule Type",
  "pages.searchTable.updateForm.schedulingPeriod.title":
    "Set Scheduling Period",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "Starting Time",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules":
    "Please choose a start time!",
  "pages.searchTable.titleDesc": "Description",
  "pages.searchTable.ruleName": "Rule name is required",
  "pages.searchTable.titleCallNo": "Number of Service Calls",
  "pages.searchTable.titleStatus": "Status",
  "pages.searchTable.nameStatus.default": "default",
  "pages.searchTable.nameStatus.running": "running",
  "pages.searchTable.nameStatus.online": "online",
  "pages.searchTable.nameStatus.abnormal": "abnormal",
  "pages.searchTable.titleUpdatedAt": "Last Scheduled at",
  "pages.searchTable.exception": "Please enter the reason for the exception!",
  "pages.searchTable.titleOption": "Option",
  "pages.searchTable.config": "Configuration",
  "pages.searchTable.subscribeAlert": "Subscribe to alerts",
  "pages.searchTable.title": "Enquiry Form",
  "pages.searchTable.new": "New",
  "pages.searchTable.chosen": "chosen",
  "pages.searchTable.item": "item",
  "pages.searchTable.totalServiceCalls": "Total Number of Service Calls",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.batchDeletion": "batch deletion",
  "pages.searchTable.batchApproval": "batch approval",
  // Welcome page
  "pages.welcome.title": "Overview",
  "pages.welcome.todayOpenCount": "Today's Open Count",
  "pages.welcome.todayCloseCount": "Today's Close Count",
  "pages.welcome.todayMemberCount": "Today's Member Count",
  "pages.welcome.openStatistics": "Open Statistics",
  "pages.welcome.period.week": "Week",
  "pages.welcome.period.month": "Month",
  "pages.welcome.chart.openCount": "Open Count",
  "pages.welcome.chart.times": "times",
  // Member Access History page
  "pages.memberAccessHistory.title": "Member Access History",
  "pages.memberAccessHistory.column.date": "Date",
  "pages.memberAccessHistory.column.memberId": "Member ID",
  "pages.memberAccessHistory.column.memberName": "Member Name",
  "pages.memberAccessHistory.column.memberPhone": "Phone",
  "pages.memberAccessHistory.column.memberEmail": "Email",
  "pages.memberAccessHistory.column.anomalyCount": "Anomaly Count",
  "pages.memberAccessHistory.column.action": "Action",
  "pages.memberAccessHistory.column.viewDetail": "View Detail",
  "pages.memberAccessHistory.column.selectDate": "Please select date",
  "pages.memberAccessHistory.detail.title": "Member Access Detail",
  "pages.memberAccessHistory.detail.column.time": "Time",
  "pages.memberAccessHistory.detail.column.action": "Action",
  "pages.memberAccessHistory.detail.column.status": "Status",
  "pages.memberAccessHistory.detail.column.operator": "Operator",
  "pages.memberAccessHistory.detail.column.countDeducted": "Count Deducted",
  "pages.memberAccessHistory.detail.countDeducted.yes": "Yes",
  "pages.memberAccessHistory.detail.countDeducted.no": "No",
  "pages.memberAccessHistory.detail.action.open": "Open",
  "pages.memberAccessHistory.detail.action.close": "Close",
  "pages.memberAccessHistory.detail.status.success": "Success",
  "pages.memberAccessHistory.detail.status.failed": "Failed",
  "pages.memberAccessHistory.detail.operator.user": "User",
  "pages.memberAccessHistory.detail.operator.member": "Member",
  "pages.memberAccessHistory.detail.operator.unknown": "Unknown",
  // Members page
  "pages.members.title": "Member List",
  "pages.members.column.id": "ID",
  "pages.members.column.name": "Name",
  "pages.members.column.phone": "Phone",
  "pages.members.column.email": "Email",
  "pages.members.column.address": "Address",
  "pages.members.column.status": "Status",
  "pages.members.column.membershipType": "Membership Type",
  "pages.members.column.remainingTime": "Remaining Availability",
  "pages.members.remainingTime.expired": "Expired",
  "pages.members.remainingTime.days": "Days",
  "pages.members.remainingTime.hours": "Hours",
  "pages.members.remainingTime.minutes": "Minutes",
  "pages.members.remainingTime.countUnit": "Times",
  "pages.members.column.createdAt": "Created At",
  "pages.members.column.action": "Action",
  "pages.members.column.remark": "Remark",
  "pages.members.column.tip.memberId": "Member ID",
  "pages.members.status.pending": "Pending",
  "pages.members.status.active": "Active",
  "pages.members.status.inactive": "Inactive",
  "pages.members.action.activate": "Activate",
  "pages.members.membershipType.time": "Time-based",
  "pages.members.membershipType.count": "Count-based",
  "pages.members.button.renewalBufferOnly": "Expiring Soon",
  "pages.members.button.showAll": "Show All",
  "pages.members.action.renew": "Renew",
  "pages.members.action.rechargeRecords": "Recharge Records",
  "pages.members.action.edit": "Edit",
  "pages.members.action.delete": "Delete",
  "pages.members.action.delete.success": "Delete successful",
  "pages.members.action.delete.failed": "Delete failed, please try again",
  "pages.members.action.confirm.activate":
    "Are you sure to activate this member?",
  "pages.members.action.confirm.activateDesc":
    "After activation, the member will be able to use system functions",
  "pages.members.action.confirm.delete": "Are you sure to delete this member?",
  "pages.members.action.confirm.ok": "OK",
  "pages.members.action.confirm.cancel": "Cancel",
  "pages.members.placeholder.selectStatus": "Please select status",
  // Activate form
  "pages.members.activateForm.title": "Set Expiration Time",
  "pages.members.activateForm.membershipType.label": "Membership Type",
  "pages.members.activateForm.membershipType.required": "Please select membership type",
  "pages.members.activateForm.expireDate.label": "Expiration Time",
  "pages.members.activateForm.expireDate.required": "Please select expiration time",
  "pages.members.activateForm.expireDate.placeholder": "Please select",
  "pages.members.activateForm.expireDate.extra": "Select expiration date, the system will set it to 23:59:59 on that date",
  "pages.members.activateForm.renewalBufferHours.label": "Renewal Buffer Period (Hours)",
  "pages.members.activateForm.renewalBufferHours.extra": "After membership expires, it can still be used within the buffer period (time-based members recorded by hour)",
  "pages.members.activateForm.remainingCount.label": "Remaining Count",
  "pages.members.activateForm.remainingCount.required": "Please enter remaining count",
  "pages.members.activateForm.remainingCount.min": "Remaining count must be greater than 0",
  "pages.members.activateForm.remainingCount.max": "Remaining count cannot exceed 999999",
  "pages.members.activateForm.remainingCount.placeholder": "Please enter remaining count (1-999999)",
  "pages.members.activateForm.remark.label": "Remarks",
  "pages.members.activateForm.remark.placeholder": "Please enter remarks",
  "pages.members.activateForm.error.memberIdRequired": "Member ID cannot be empty",
  "pages.members.activateForm.error.memberIdInvalid": "Invalid member ID format, please refresh the page and try again",
  "pages.members.activateForm.error.timeBasedExpireDateRequired": "Time-based membership must set expiration time",
  "pages.members.activateForm.error.countBasedRemainingCountRequired": "Count-based membership must set valid count",
  "pages.members.activateForm.success": "Activation successful",
  "pages.members.activateForm.error.failed": "Activation failed, please try again",
  "pages.members.activateForm.error.refresh": ", please refresh the page and try again",
  // Recharge records
  "pages.members.rechargeRecords.title": "Recharge Records",
  "pages.members.rechargeRecords.close": "Close",
  "pages.members.rechargeRecords.noRecords": "No recharge records",
  "pages.members.rechargeRecords.operationTime": "Operation Time",
  "pages.members.rechargeRecords.type": "Type",
  "pages.members.rechargeRecords.status": "Status",
  "pages.members.rechargeRecords.status.valid": "Valid",
  "pages.members.rechargeRecords.status.invalid": "Invalid",
  "pages.members.rechargeRecords.daysAdded": "Days Added",
  "pages.members.rechargeRecords.daysUnit": "Days",
  "pages.members.rechargeRecords.countAdded": "Count Added",
  "pages.members.rechargeRecords.countUnit": "Times",
  "pages.members.rechargeRecords.remark": "Remarks",
  "pages.members.rechargeRecords.revoke": "Revoke",
  "pages.members.rechargeRecords.error.recordIdNotFound": "Record ID not found",
  "pages.members.rechargeRecords.success.revoke": "Revoke successful",
  "pages.members.rechargeRecords.error.revokeFailed": "Revoke failed, please try again",
  "pages.members.rechargeRecords.error.fetchFailed": "Failed to fetch recharge records, please try again",
  "pages.members.rechargeRecords.remark.memberActivation": "Member Activation",
  // Renew form
  "pages.members.renewForm.title": "Renewal",
  "pages.members.renewForm.currentRemainingTime": "Current member remaining available time:",
  "pages.members.renewForm.expireTime": "Expiration time:",
  "pages.members.renewForm.remainingCount": "Remaining count:",
  "pages.members.renewForm.countUnit": "Times",
  "pages.members.renewForm.timeUnit.days": "Days",
  "pages.members.renewForm.timeUnit.hours": "Hours",
  "pages.members.renewForm.timeUnit.minutes": "Minutes",
  "pages.members.renewForm.expired": "Expired",
  "pages.members.renewForm.newExpireDate.label": "New Expiration Date",
  "pages.members.renewForm.newExpireDate.required": "Please select new expiration date",
  "pages.members.renewForm.newExpireDate.placeholder": "Please select",
  "pages.members.renewForm.newExpireDate.extra": "Select new expiration date, the system will set it to 23:59:59 on that date",
  "pages.members.renewForm.newExpireDate.mustBeLater": "New expiration date must be later than current expiration date",
  "pages.members.renewForm.renewalBufferHours.label": "Renewal Buffer Period (Hours)",
  "pages.members.renewForm.renewalBufferHours.extra": "After membership expires, it can still be used within the buffer period (time-based members recorded by hour, leave blank to keep the original buffer period unchanged)",
  "pages.members.renewForm.countToAdd.label": "Renewal Increase Count",
  "pages.members.renewForm.countToAdd.required": "Please enter the count to add",
  "pages.members.renewForm.countToAdd.min": "Count to add must be greater than 0",
  "pages.members.renewForm.countToAdd.max": "Count to add cannot exceed 999999",
  "pages.members.renewForm.countToAdd.placeholder": "Please enter the count to add (1-999999)",
  "pages.members.renewForm.remark.label": "Remarks",
  "pages.members.renewForm.remark.placeholder": "Please enter remarks",
  "pages.members.renewForm.error.memberIdRequired": "Member ID cannot be empty",
  "pages.members.renewForm.error.membershipTypeRequired": "Membership type cannot be empty, please refresh the page and try again",
  "pages.members.renewForm.success": "Renewal successful",
  "pages.members.renewForm.error.failed": "Renewal failed, please try again",
  // Create member form
  "pages.members.createForm.title": "New Member",
  "pages.members.createForm.name.label": "Name",
  "pages.members.createForm.name.required": "Please enter name",
  "pages.members.createForm.name.placeholder": "Please enter name",
  "pages.members.createForm.phone.label": "Phone Number",
  "pages.members.createForm.phone.placeholder": "Please enter phone number",
  "pages.members.createForm.email.label": "Email",
  "pages.members.createForm.email.invalid": "Please enter a valid email address",
  "pages.members.createForm.email.placeholder": "Please enter email",
  "pages.members.createForm.password.label": "Password",
  "pages.members.createForm.password.required": "Please enter password",
  "pages.members.createForm.password.min": "Password must be at least 6 characters",
  "pages.members.createForm.password.placeholder": "Please enter password (at least 6 characters)",
  "pages.members.createForm.password.extra": "Password will be used for member login verification",
  "pages.members.createForm.address.label": "Address",
  "pages.members.createForm.address.placeholder": "Please enter address",
  "pages.members.createForm.status.label": "Status",
  "pages.members.createForm.status.placeholder": "Please select status",
  "pages.members.createForm.remark.label": "Remarks",
  "pages.members.createForm.remark.placeholder": "Please enter remarks",
  "pages.members.createForm.error.emailOrPhoneRequired": "Please enter at least email or phone number",
  "pages.members.createForm.contactType.label": "Contact Method",
  "pages.members.createForm.contactType.required": "Please select contact method type",
  "pages.members.createForm.contactType.email": "Email",
  "pages.members.createForm.contactType.phone": "Phone Number",
  "pages.members.createForm.error.contactTypeRequired": "Please select contact method type (email or phone number)",
  "pages.members.createForm.error.emailRequired": "Please enter email address",
  "pages.members.createForm.error.phoneRequired": "Please enter phone number",
  "pages.members.createForm.error.bothProvided": "Email and phone number can only choose one",
  "pages.members.createForm.success": "Create successful",
  "pages.members.createForm.error.failed": "Create failed, please try again",
  // Update member form
  "pages.members.updateForm.title": "Edit Member",
  "pages.members.updateForm.name.label": "Name",
  "pages.members.updateForm.name.required": "Please enter name",
  "pages.members.updateForm.name.placeholder": "Please enter name",
  "pages.members.updateForm.phone.label": "Phone Number",
  "pages.members.updateForm.phone.placeholder": "Please enter phone number",
  "pages.members.updateForm.phone.extra": "Phone number cannot be modified",
  "pages.members.updateForm.email.label": "Email",
  "pages.members.updateForm.email.invalid": "Please enter a valid email address",
  "pages.members.updateForm.email.placeholder": "Please enter email",
  "pages.members.updateForm.email.extra": "Email cannot be modified",
  "pages.members.updateForm.password.label": "Password",
  "pages.members.updateForm.password.min": "Password must be at least 6 characters",
  "pages.members.updateForm.password.placeholder": "Leave blank to not modify password",
  "pages.members.updateForm.password.extra": "Leave blank to not modify password",
  "pages.members.updateForm.address.label": "Address",
  "pages.members.updateForm.address.placeholder": "Please enter address",
  "pages.members.updateForm.status.label": "Status",
  "pages.members.updateForm.status.placeholder": "Please select status",
  "pages.members.updateForm.membershipType.label": "Membership Type",
  "pages.members.updateForm.membershipType.extra": "After modifying membership type, the member needs to be reactivated",
  "pages.members.updateForm.remark.label": "Remarks",
  "pages.members.updateForm.remark.placeholder": "Please enter remarks",
  "pages.members.updateForm.success": "Update successful",
  "pages.members.updateForm.error.failed": "Update failed, please try again",
  // Users page
  "pages.users.title": "User List",
  "pages.users.column.id": "ID",
  "pages.users.column.email": "Email",
  "pages.users.column.phone": "Phone",
  "pages.users.column.name": "Name",
  "pages.users.column.role": "Role",
  "pages.users.column.status": "Status",
  "pages.users.column.createdAt": "Created At",
  "pages.users.column.action": "Action",
  "pages.users.column.tip.userId": "User ID",
  "pages.users.role.admin": "Admin",
  "pages.users.role.editor": "Editor",
  "pages.users.role.viewOnly": "View Only",
  "pages.users.status.active": "Active",
  "pages.users.status.inactive": "Inactive",
  "pages.users.action.edit": "Edit",
  "pages.users.action.delete": "Delete",
  "pages.users.action.confirm.delete": "Are you sure to delete this user?",
  // Create user form
  "pages.users.createForm.title": "New User",
  "pages.users.createForm.email.label": "Email",
  "pages.users.createForm.email.invalid": "Please enter a valid email address",
  "pages.users.createForm.email.placeholder": "Please enter email (at least one of email or phone number)",
  "pages.users.createForm.phone.label": "Phone Number",
  "pages.users.createForm.phone.placeholder": "Please enter phone number (at least one of email or phone number)",
  "pages.users.createForm.password.label": "Password",
  "pages.users.createForm.password.required": "Please enter password",
  "pages.users.createForm.password.min": "Password must be at least 6 characters",
  "pages.users.createForm.password.placeholder": "Please enter password (at least 6 characters)",
  "pages.users.createForm.name.label": "Name",
  "pages.users.createForm.name.placeholder": "Please enter name",
  "pages.users.createForm.role.label": "Role",
  "pages.users.createForm.role.placeholder": "Please select role",
  "pages.users.createForm.role.admin": "Admin (can add, delete, edit, and view)",
  "pages.users.createForm.role.editor": "Editor (can edit)",
  "pages.users.createForm.role.viewOnly": "View Only (can only view)",
  "pages.users.createForm.status.label": "Status",
  "pages.users.createForm.status.placeholder": "Please select status",
  "pages.users.createForm.status.active": "Active",
  "pages.users.createForm.status.inactive": "Inactive",
  "pages.users.createForm.error.emailOrPhoneRequired": "Please enter at least email or phone number",
  "pages.users.createForm.success": "Create successful",
  "pages.users.createForm.error.failed": "Create failed, please try again",
  // Update user form
  "pages.users.updateForm.title": "Edit User",
  "pages.users.updateForm.email.label": "Email",
  "pages.users.updateForm.email.invalid": "Please enter a valid email address",
  "pages.users.updateForm.email.placeholder": "Please enter email",
  "pages.users.updateForm.email.extra": "Email cannot be modified",
  "pages.users.updateForm.phone.label": "Phone Number",
  "pages.users.updateForm.phone.placeholder": "Please enter phone number",
  "pages.users.updateForm.phone.extra": "Phone number cannot be modified",
  "pages.users.updateForm.password.label": "Password",
  "pages.users.updateForm.password.min": "Password must be at least 6 characters",
  "pages.users.updateForm.password.placeholder": "Leave blank to not modify password",
  "pages.users.updateForm.password.extra": "Leave blank to not modify password",
  "pages.users.updateForm.name.label": "Name",
  "pages.users.updateForm.name.placeholder": "Please enter name",
  "pages.users.updateForm.role.label": "Role",
  "pages.users.updateForm.role.placeholder": "Please select role",
  "pages.users.updateForm.role.admin": "Admin (can add, delete, edit, and view)",
  "pages.users.updateForm.role.editor": "Editor (can edit)",
  "pages.users.updateForm.role.viewOnly": "View Only (can only view)",
  "pages.users.updateForm.role.extra": "Editor role cannot modify user roles",
  "pages.users.updateForm.status.label": "Status",
  "pages.users.updateForm.status.placeholder": "Please select status",
  "pages.users.updateForm.status.active": "Active",
  "pages.users.updateForm.status.inactive": "Inactive",
  "pages.users.updateForm.success": "Update successful",
  "pages.users.updateForm.error.failed": "Update failed, please try again",
};
